// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { LMFormPersonalization } from '@states/models';
import { LMPersonalizationPersistenceService } from '@services/lm-personalization-persistence.service';

@Injectable()
export class LMFormPersonalizationService {
  constructor(private lmSessionStorageService: LMPersonalizationPersistenceService) {
  }

  public getFormPersonalization(formPersonalizationKeyParams: LMFormPersonalizationKeyParams): LMFormPersonalization {
    return this.lmSessionStorageService.getPersonalization(formPersonalizationKeyParams.key);
  }

  public saveFormPersonalization(formPersonalizationKeyParams: LMFormPersonalizationKeyParams, formPersonalizationItem: LMFormPersonalization) {
    this.lmSessionStorageService.persistPersonalization(formPersonalizationKeyParams.key, formPersonalizationItem);
  }

  public deletePersonalization(formPersonalizationKeyParams: LMFormPersonalizationKeyParams): void {
    this.lmSessionStorageService.removePersonalization(formPersonalizationKeyParams.key);
  }
}

export class LMFormPersonalizationKeyParams {
  storageKey: string;
  resourceId: string;
  contextResourceId?: string;

  private _key = '';

  get key() {
    if (!this._key) {
      this.buildKey();
    }
    return this._key;
  }

  private buildKey(): void {
    this._key = this.storageKey;
    this._key = this._key.replace('{resourceId}', this.resourceId);
    this._key = this._key.replace('{contextResourceId}', this.contextResourceId);
  }
}
